<template>
	<div class="com-container">
		<div class="title" :style="comStyle">  <!-- 这里 comStyle 是计算属性  -->
			<span>{{ '▎ ' +  showTitle }}</span> <!-- 这里 showTitle 是计算属性  -->
			<span class="iconfont title-icon" :style="comStyle" @click="showChoice = !showChoice">&#xe6eb;</span>
			<div class="select-con" v-show="showChoice" :style="marginStyle">    <!-- 这里 marginStyle 是计算属性  -->
				<div class="select-item" v-for="item in selectTypes" :key="item.key" @click="handleSelect(item.key)">
					{{item.text}}
				</div>
				<!-- <div class="select-item">
					我是选择标题2
				</div>
				<div class="select-item">
					我是选择标题3
				</div> -->
			</div>
		</div>
		<div class="com-chart" ref="trend_ref"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				chartInstane: null, // echart实例对象
				// showTitle: "我是标题",  // 用计算属性代替
				showChoice: false, // 是否显示可选项
				choiceType: 'map', // 显示的数据类型
				titleFontSize: 0, // 指明标题的字体大小

				// 从服务器中获取的所有数据  地区销量趋势（上海、北京、深圳、广州、重庆）、商家销量趋势、商品销量趋势
				allData: {
					"map": {
						"title": "地区销量趋势",
						"base": 310,
						"unit": "万",
						"data": [{
							"name": "上海",
							"data": ["155.13", "154.65", "171.46", "164.38", "237.23", "300.65", "240.29",
								"232.07", "193.31", "136.70", "48.64", "90.20"
							]
						}, {
							"name": "北京",
							"data": ["86.25", "33.80", "145.58", "21.79", "176.09", "132.41", "291.05", "191.89",
								"151.54", "94.25", "141.75", "157.14"
							]
						}, {
							"name": "深圳",
							"data": ["143.94", "186.29", "183.64", "251.48", "195.48", "152.16", "52.47", "184.12",
								"203.79", "39.16", "56.37", "161.64"
							]
						}, {
							"name": "广州",
							"data": ["57.60", "77.61", "307.24", "165.05", "175.41", "276.88", "269.04", "296.11",
								"105.31", "283.39", "134.08", "265.38"
							]
						}, {
							"name": "重庆",
							"data": ["200.82", "215.56", "249.80", "222.67", "216.98", "60.12", "309.68", "273.35",
								"150.99", "251.97", "26.15", "186.99"
							]
						}]
					},
					"seller": {
						"title": "商家销量趋势",
						"base": 120,
						"unit": "万",
						"data": [{
							"name": "商家1",
							"data": ["33.00", "86.07", "28.77", "34.29", "102.45", "0.30", "50.50", "21.70",
								"25.41", "25.71", "66.90", "63.29"
							]
						}, {
							"name": "商家2",
							"data": ["12.83", "102.42", "37.37", "95.55", "45.45", "112.72", "113.53", "106.41",
								"75.67", "113.91", "37.32", "28.04"
							]
						}, {
							"name": "商家3",
							"data": ["73.54", "40.92", "89.81", "113.41", "76.34", "107.15", "55.61", "0.33",
								"106.29", "78.30", "98.05", "38.67"
							]
						}, {
							"name": "商家4",
							"data": ["47.19", "73.57", "44.60", "84.03", "62.82", "15.65", "64.72", "88.98",
								"29.25", "5.41", "79.11", "118.46"
							]
						}, {
							"name": "商家5",
							"data": ["74.84", "116.45", "107.69", "11.03", "17.31", "42.22", "97.60", "108.64",
								"43.87", "110.65", "5.96", "38.41"
							]
						}]
					},
					"commodity": {
						"title": "商品销量趋势",
						"base": 50,
						"unit": "万",
						"data": [{
							"name": "女装",
							"data": ["47.71", "13.34", "19.30", "7.93", "41.93", "23.01", "22.63", "26.91", "0.62",
								"39.23", "48.74", "29.48"
							]
						}, {
							"name": "手机数码",
							"data": ["46.66", "46.52", "23.65", "1.73", "44.26", "47.07", "17.86", "40.20", "3.78",
								"31.46", "28.01", "8.63"
							]
						}, {
							"name": "男装",
							"data": ["26.98", "30.71", "42.59", "29.50", "26.86", "17.65", "30.15", "15.85",
								"9.28", "30.20", "32.35", "34.46"
							]
						}, {
							"name": "大家电",
							"data": ["20.26", "46.23", "43.84", "46.75", "28.29", "32.36", "45.30", "16.73",
								"40.40", "45.07", "29.86", "41.92"
							]
						}, {
							"name": "美妆护肤",
							"data": ["7.58", "23.66", "39.78", "30.20", "25.72", "36.20", "47.55", "35.39",
								"27.85", "37.56", "16.91", "3.91"
							]
						}]
					},
					"common": {
						"month": ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
					},
					"type": [{
							"key": "map",
							"text": "地区销量趋势"
						},
						{
							"key": "seller",
							"text": "商家销量趋势"
						},
						{
							"key": "commodity",
							"text": "商品销量趋势"
						},
					]
				},
			}
		},
		mounted() {
			this.initChart()
			this.getData()
			window.addEventListener('resize', this.screenAdapter) // 分辨率的适配
			this.screenAdapter() // 主动调一次各种尺寸的计算
		},
		destroyed() {
			window.removeEventListener('resize', this.screenAdapter) // 取消监听
		},
		computed: { // 计算属性用于一个值依赖另一个值的情况  selectTypes 依赖于 获取的数据 this.allData.type
			selectTypes() {
				if (!this.allData) {
					return []
				} else {
					// return this.allData.type
					return this.allData.type.filter(item => {
						return item.key !== this.choiceType
					}) // 筛选过滤掉已经选中的值
				}
			},
			showTitle() { // showTitle 依赖于 选择的 choiceType
				if (!this.allData) {
					return ''
				} else {
					return this.allData[this.choiceType].title
				}
			},
			// 设置给标题的样式，因为标题是自己定义的，无法通过 adapterOption 来设置，所以通过计算属性
			comStyle() {
				return {
					fontSize: this.titleFontSize + 'px',
					// color: getThemeValue(this.theme).titleColor
				}
			},
			marginStyle () {
			  return {
			    marginLeft: this.titleFontSize + 'px'
			  }
			},
			// ...mapState(['theme'])
		},
		methods: {
			initChart() { // 初始化实例对象的方法
				this.chartInstane = this.echarts.init(this.$refs.trend_ref, 'chalk')
				const initOption = {
					xAxis: {
						type: 'category', // x轴为类目轴
						boundaryGap: false // 是否需要间隙  让折线图开端紧挨边缘
					},
					yAxis: {
						type: 'value' // y轴为数据轴
					},
					grid: { // 直角坐标系 控制整个坐标轴的大小
						top: '35%',
						left: '3%',
						right: '4%',
						bottom: '1%',
						containLabel: true // 距离是包含坐标轴上的文字
					},
					tooltip: { /// 鼠标接触坐标轴触发工具提示
						trigger: 'axis'
					},
					legend: { // 图例的位置与形状
						left: 20,
						top: '15%',
						// icon: 'circle'
					},
				}
				this.chartInstane.setOption(initOption)
			},
			getData() {
				// this.getRequest('/work_log/header_index1').then(resp => {
				// 	if (resp) {
				// 		this.allData = resp.data
				this.updateChart() // 更新图表
				// 	}
				// })
			},
			updateChart() { //处理数据  更新数据
				// 半透明的颜色值
				const colorArr1 = [
					'rgba(11, 168, 44, 0.5)',
					'rgba(44, 110, 255, 0.5)',
					'rgba(22, 242, 217, 0.5)',
					'rgba(254, 33, 30, 0.5)',
					'rgba(250, 105, 0, 0.5)'
				]
				// 全透明的颜色值
				const colorArr2 = [
					'rgba(11, 168, 44, 0)',
					'rgba(44, 110, 255, 0)',
					'rgba(22, 242, 217, 0)',
					'rgba(254, 33, 30, 0)',
					'rgba(250, 105, 0, 0)'
				]
				// 数据处理 begin
				const timeArr = this.allData.common.month // 类目轴的数据处理
				// const valueArr = this.allData.map.data // 取地区销售趋势数据
				const valueArr = this.allData[this.choiceType].data
				const seriesArr = valueArr.map((item, index) => { // 遍历 valueArr （5个对象，每个对象有1个数组，每个数组就是一条折线图）
					return {
						name: item.name, // 图例名字
						type: 'line',
						data: item.data, // y轴数据 数组
						// stack: 'map', // 堆叠图 只要5条折线图stack属性的值相同就是堆叠图
						stack: this.choiceType,
						areaStyle: { //区域面积  折线图与X轴之间颜色填充的面积
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1,
								[{ //颜色渐变 从半透明到全透明（一般底色是深色采用） 指明颜色渐变的方向   四个值分别是 x1,y1,x2,y2 分别代表(x1,y1) (x2,y2) 两个点； （0,0）代表矩形的左上角即坐标原点   ； （1,0）代表矩形的右上角 ；  （0,1）代表矩形的左下角； （1,1）代表矩形的右下角；
										offset: 0, // 0%
										color: colorArr1[index]
									}, // %0的颜色值
									{
										offset: 1, // 100%
										color: colorArr2[index]
									} // 100%的颜色值
								])
						}
					}
				})
				const legendArr = valueArr.map(item => { // 获取图例的数据  名字数组
					return item.name
				})
				const dataOption = {
					xAxis: {
						data: timeArr // 类目轴赋值
					},
					legend: { // 图例名字数组 图例数据
						data: legendArr
					},
					series: seriesArr // 数据轴赋值
				}
				this.chartInstane.setOption(dataOption)
			},
			screenAdapter() {
				this.titleFontSize = this.$refs.trend_ref.offsetWidth / 100 * 3.6
				const adapterOption = {
					legend: {  // 图例自适应
						itemWidth: this.titleFontSize,   // 图例的宽度
						itemHeight: this.titleFontSize,  // 图例的高度
						itemGap: this.titleFontSize,     // 图例的间隙
						textStyle: {  // 图例的文字
							fontSize: this.titleFontSize / 2
						}
					}
				}
				this.chartInstane.setOption(adapterOption)
				this.chartInstane.resize()
			},
			handleSelect(currentType) {
				this.choiceType = currentType
				this.updateChart()
				this.showChoice = false
			}
		}
	}
</script>

<style scoped>
	.title {
		position: absolute;
		/* 让div不占位置 */
		z-index: 10;
		/* 设置div层级，让divx显示出来 */
		color: #FFFFFF;
		left: 20px;
		top: 20px;
	}


	.title-icon {
		margin-left: 10px;
		cursor: pointer;
		/* 鼠标变小手  */
	}

	.select-con {
		background-color: #222733;
	}
</style>
